import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/en'
import 'dayjs/locale/es'

import './styles/global.css'
import { queryClient } from './core/query/queryClient'
import { AuthProvider } from './core/auth/AuthProvider'
import { AppRoutes } from './core/router/AppRoutes'
import { LeafDefs } from './shared/leaf/LeafDefs'
import { ToastProvider } from './shared/feedback/toast'
import { I18nextProvider } from 'react-i18next'
import i18n from './core/i18n/i18n'
import { LocalizedDates } from './core/i18n/LocalizedDates'
import { ColorModeProvider } from './core/prefs/ColorModeProvider'
import { AssistenteProvider } from './features/assistente/AssistenteProvider'

/**
 * Sobe o MSW apenas em DEV com VITE_USE_MOCKS=true. Import dinâmico → o mock
 * fica FORA do bundle de produção (nunca intercepta a API real).
 */
async function enableMocks() {
  if (!import.meta.env.DEV || import.meta.env.VITE_USE_MOCKS !== 'true') return
  const { worker } = await import('./mocks/browser')
  await worker.start({ onUnhandledRequest: 'bypass', quiet: true })
}

async function bootstrap() {
  await enableMocks()

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <ColorModeProvider>
            <LeafDefs />
            <LocalizedDates>
              <ToastProvider>
                <BrowserRouter>
                  <AuthProvider>
                    {/* Dentro do AuthProvider: o gate do assistente lê a permissão
                        e o usuário. Fora das rotas: a conversa não some ao navegar. */}
                    <AssistenteProvider>
                      <AppRoutes />
                    </AssistenteProvider>
                  </AuthProvider>
                </BrowserRouter>
              </ToastProvider>
            </LocalizedDates>
          </ColorModeProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
}

void bootstrap()
